import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { ReviewEmailMember, ReviewMember, ScheduledReview } from 'types'
import { buildErrorMessage } from 'utils'
import { ReviewPrivacy } from 'components/ReviewsWizard/types'
import { ReviewFrequency } from '../../../components/ReviewsWizard/ReviewersSelection/constants'

export interface Data {
  scheduled_review: ScheduledReview
}

export interface Variables {
  article_id: string
  name: string
  interval?: string
  first_occurrence: string
  end_date?: string
  occurrences?: number
  duration: number
  members: ReviewMember[]
  email_members: ReviewEmailMember[]
  privacy: ReviewPrivacy
  description?: string | null
  html_description?: string | null
  frequency: ReviewFrequency
  weekdays: string[]
}

export const useCreateScheduledReview = () =>
  useMutation<Data, unknown, Variables>('createScheduledReview', async (variables) => {
    const { article_id, ...rest } = variables
    const response = await sendToApi<{ scheduled_review: ScheduledReview }>(
      `/articles/${article_id}/scheduled_reviews`,
      {
        method: 'POST',
        body: { ...rest, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone },
      },
    )
    if (response.type !== SUCCESS_RESPONSE_TYPE) {
      throw new Error(
        buildErrorMessage(response.data.errors) ||
          'An error occurred! Our team has been notified and we are looking into it.',
      )
    }
    return response.data
  })
